
import { PureConnect, React } from '../../react';
import HOVER_ITEM from './actions/HOVER';
import { ICategory } from '../../types';
import cx from './categoryblock.less';

interface ICategoryblockProps {
    item: ICategory;
    itemno?: number;    
    selected: boolean;
    onSelect: any;
    onEdit: any;
    onDelete: any;
}

export const CategoryBlock = PureConnect<any|ICategoryblockProps>(`CategoryBlock`)(
    (state) => ({
        hoveredId : state.admin.hoveredId,
    }),
    (dispatch) => ({
        hoverItem: (hoveredId: string) => dispatch(HOVER_ITEM({hoveredId })),
        hoverItemOut: () => dispatch(HOVER_ITEM({hoveredId: '' })),
    }),
    ({ item, selected, onSelect, onEdit, onDelete, hoveredId, hoverItemOut, hoverItem, extraClassNames }) => {
    
    let category: ICategory = item;
    return (
        <div key={item.id} className={cx('container', extraClassNames, selected ? 'selected' : '')} onMouseEnter={() =>hoverItem(item.id)} onMouseLeave={() => hoverItemOut()}>
            <div className={cx('left-side-area')}>
                <div className={cx('default-checkbox-div', 'check-box-selection')} 
                    key={item.id}
                    tabIndex={-1}>
                    <input type="checkbox" 
                        className={cx('default-checkbox')} 
                        tabIndex={-1}  
                        checked={selected}
                        onChange={() => onSelect(category)}
                        aria-hidden={true}/>
                    <div role="checkbox" 
                        className={cx('checkmark')}
                        aria-checked={selected ? 'true': 'false'}
                        
                        tabIndex={0}
                        onKeyPress={(ev: any)=> { if (ev.key==='Enter') { onSelect(category);}}}
                        onClick={() => onSelect(category)}>
                    </div> 
                </div>
            </div>
            <div className={cx('middle-container')}>
                <div className={cx('light-color-left-container')} style={{ backgroundColor: lighterColor(category.color) }}>
                    <span className={cx('color-left-container')} style={{ backgroundColor: category.color }}></span>
                </div>
                <div className={cx('text-container')}>
                    <span className={cx('text-container-page')}>
                        {category.name}
                    </span>
                    </div>                                                         
            </div>               
            { hoveredId === item.id ? 
                <div className={cx('right-side-area')}>
                    <span className={cx('icon-edit')} onClick={() => onEdit(category)}></span>
                    <span className={cx('icon-delete')} onClick={() => onDelete(category)}> </span>
                </div>
                :null
            } 
        </div>
    );
  });

function lighterColor(hex: any) {
    const const95=95;
    let {h, s} = HexToHSL(hex);
    return hslToHex(h, s, const95);
}

function HexToHSL(hex: any) {
var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
if (!result) return {h:0, l:0 }; // , l};
const const16=16;
const const05=0.5;
const const1=1;
const const2=2;
const const3=3;
const const4=4;
const const6=6;
const const255=255;
const const100=100;
const const360=360;

var r = parseInt(result[const1], const16);
var g = parseInt(result[const2], const16);
var b = parseInt(result[const3], const16);

r /= const255, g /= const255, b /= const255;
var max = Math.max(r, g, b);
var min = Math.min(r, g, b);
var h;
var s;
var l = (max + min) / const2;

if(max === min) {
    h = s = 0; // achromatic
} else {
    var d = max - min;
    s = l > const05 ? d / (const2 - max - min) : d / (max + min);
    switch(max) {
        case r: h = (g - b) / d + (g < b ? const6 : 0); break;
        case g: h = (b - r) / d + const2; break;
        case b: h = (r - g) / d + const4; break;
    }
    
    h /= const6;
}

s = s*const100;
s = Math.round(s);
l = l*const100;
l = Math.round(l);
h = Math.round(const360*h);

return {h, s }; // , l};
}

function hslToHex(h: any, s: any, l: any) {
    const const100=100; const const30=30; const const3=3; const const2=2; const const9=9;
    const const255=255; const const16=16; const const4=4; const const8=8; const const0=0;
    const const12=12;
    l /= const100;
    const a = s * Math.min(l, 1 - l) / const100;
    const f = (n: any) => {
      const k = (n + h / const30) % const12;
      const color = l - a * Math.max(Math.min(k - const3, const9 - k, 1), -1);
      return Math.round(const255 * color).toString(const16).padStart(const2, '0');   // convert to Hex and prefix "0" if needed
    };
    return `#${f(const0)}${f(const8)}${f(const4)}`;
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/admin/categoryblock.tsx